/**
 * CompletionCheckCard - web用スタイリングラッパー
 *
 * @kyumo/shared-ui の CompletionCheckResultView に web 固有の usage 表示を適用。
 */

import { getTotalTokens } from '@kyumo/common';
import { CompletionCheckResultView } from '@kyumo/shared-ui';
import { formatCost, formatNumber } from './chart-utils';

export interface CompletionCheckCardProps {
  result: unknown;
}

export function CompletionCheckCard({ result }: CompletionCheckCardProps) {
  return (
    <CompletionCheckResultView
      result={result}
      className="mt-2"
      renderUsage={(usage) => {
        const totalTokens = getTotalTokens(usage);
        const costTotal = usage.costs?.total ?? usage.cost;
        return (
          <>
            <span>{formatNumber(totalTokens)} tokens</span>
            {costTotal !== undefined && (
              <span className="text-yellow-400">{formatCost(costTotal)}</span>
            )}
          </>
        );
      }}
    />
  );
}
